import { useAppDispatch, useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import { useEffect } from 'react'
import {
  areImportingJobsPending,
  getImportingJobsNotCleared,
  getImportingJobsRequest,
  setImportingJobsCleared
} from '../../state/jobsImportingSlice'
import { hasEditionRole } from 'features/users/model/user'

function useImportingJobs() {
  const dispatch = useAppDispatch()
  const userMe = useAppSelector((state) => state.users.me)
  const importingJobsStatus = useAppSelector((state) => state.jobsImporting.importingJobsStatusRequest)
  const importingJobs = useAppSelector((state) => state.jobsImporting.importingJobs)
  const importingJobsNotCleared = useAppSelector(getImportingJobsNotCleared)
  const areAnyImportingJobsPending = useAppSelector(areImportingJobsPending)

  const clearJobs = () => {
    dispatch(setImportingJobsCleared())
  }

  useEffect(() => {
    if (!hasEditionRole(userMe)) return

    if (importingJobsStatus === RequestStatus.Idle) {
      const now = new Date()
      const lastTwentyFourHours = new Date(now.setDate(now.getDate() - 1)).toString()

      dispatch(
        getImportingJobsRequest({
          owner: userMe?.user_id,
          createdSince: lastTwentyFourHours,
          status: 'pending,running,success,failure'
        })
      )
    }
  }, [importingJobsStatus, userMe, dispatch])

  return {
    importingJobs,
    importingJobsNotCleared,
    clearJobs,
    areAnyImportingJobsPending
  }
}

export default useImportingJobs
